interface ConditionalWrapperProps {
  condition?: boolean;
  WrapperComponent?: React.FC;
}

const ConditionalWrapper: React.FC<ConditionalWrapperProps> = (props) => {
  return (
    props.condition && props.WrapperComponent ? (
      <props.WrapperComponent>
        {props.children}
      </props.WrapperComponent>
    ) : (
      <>
        {props.children}
      </>
    )
  );
};

export default ConditionalWrapper;
